import { createSlice } from '@reduxjs/toolkit'

export const acctknSlice = createSlice({
  name: 'accessToken',
  initialState: {
    value: '',
  },
  reducers: {
    setToken: (state,action) => {
      state.value = action.payload;
    },
    clearToken: (state,action) => {
      state.value = ''
    },
  },
})

export const { setToken,clearToken} = acctknSlice.actions

export default acctknSlice.reducer